module.exports = __webpack_public_path__ + "static/img/carousel2.0a0ba3f6.png";